import { toast } from 'react-toastify';

/**
 * Backend (Joi) เวลา validate ไม่ผ่านจะส่งกลับ
 *   { success: false, message: 'ข้อมูลไม่ถูกต้อง', errors: ['กรุณาระบุ...', ...] }
 * โดย `message` เป็นข้อความเดียวกันทุก field (generic) — ต้องโชว์ `errors[]` รายข้อ
 * ไม่งั้นผู้ใช้ไม่รู้ว่ากรอกช่องไหนผิด เห็นแต่ "ข้อมูลไม่ถูกต้อง" ลอยๆ
 *
 * ใช้แทน `toast.error(error.response?.data?.message || 'เกิดข้อผิดพลาด')` ตรงๆ
 * ในทุกจุดที่ยิง request ไปหา endpoint ที่ validate ด้วย Joi (`validate(schema)` หรือ
 * `schema.validate()` แบบ manual ใน controller — ทั้งคู่ตอบ error shape เดียวกัน)
 */
export const toastValidationError = (error: any) => {
  const fieldErrors: unknown = error?.response?.data?.errors;

  if (Array.isArray(fieldErrors) && fieldErrors.length > 0) {
    toast.error(
      <div>
        {fieldErrors.map((msg, i) => <div key={i}>{String(msg)}</div>)}
      </div>
    );
    return;
  }

  toast.error(error?.response?.data?.message || 'เกิดข้อผิดพลาด');
};
